import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { getDescription } from 'helpers/content';
var PostContent = /*#__PURE__*/function (_Component) {
  function PostContent() {
    _classCallCheck(this, PostContent);
    return _callSuper(this, PostContent, arguments);
  }
  _inherits(PostContent, _Component);
  return _createClass(PostContent, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "post-content",
        dangerouslySetInnerHTML: {
          __html: getDescription(this.props.children)
        }
      });
    }
  }]);
}(Component);
export { PostContent as default };